import moment from "moment";

export const convertStringToDate = dateString => {
  if (!dateString) return null;
  // Handle both DD-MM-YYYY (used in DatePicker) and other common formats
  return moment(dateString, ["DD-MM-YYYY", "DD/MM/YYYY", "YYYY-MM-DD", "DD/MMM/YYYY"]).startOf('day');
};

